import { translate, changeLanguage } from '@shakkerai/util-i18n';
import { MODEL_SDXL, MODEL_FLUX } from '@shakkerai/pro-models';

window.changeLanguage = changeLanguage;

export const MIN_GENERATOR_SIZE = 512;
export const MAX_GENERATOR_SIZE = 2048;
export const MAX_GENERATE_COUNT = 4;
export const GENERATOR_ITEM_GAP = 32;

export const presetFrameSizes = [
  { isFixedRatio: true, label: '1:1', icon: [12, 12], width: 1024, height: 1024 },
  { isFixedRatio: true, label: '3:2', icon: [12, 8], width: 1152, height: 768 },
  { isFixedRatio: true, label: '2:3', icon: [8, 12], width: 768, height: 1152 },
  { isFixedRatio: true, label: '3:4', icon: [9, 12], width: 768, height: 1024 },
  { isFixedRatio: true, label: '4:3', icon: [12, 9], width: 1024, height: 768 },
  { isFixedRatio: false, label: translate('generator_size_custom'), icon: [16, 16] },
];

export const defaultHiresOptions = {
  enabled: false,
  scale: 1.5,
  upscaler: '16',
  strength: 0.5,
  steps: 20,
};

export const upscalerOptions = [
  {
    name: 'LATENT',
    value: '0',
    label: 'Latent',
  },
  {
    name: 'LATENT_ANTIALIASED',
    value: '1',
    label: 'Latent (antialiased)',
  },
  {
    name: 'LATENT_BICUBIC',
    value: '2',
    label: 'Latent (bicubic)',
  },
  {
    name: 'LATENT_BICUBIC_ANTIALIASED',
    value: '3',
    label: 'Latent (bicubic antialiased)',
  },
  {
    name: 'LATENT_NEAREST',
    value: '4',
    label: 'Latent (nearest)',
  },
  {
    name: 'LATENT_NEAREST_EXACT',
    value: '5',
    label: 'Latent (nearest-exact)',
  },
  {
    name: 'LANCZOS',
    value: '6',
    label: 'Lanczos',
  },
  {
    name: 'NEAREST',
    value: '7',
    label: 'Nearest',
  },
  {
    name: 'ESRGAN_4X',
    value: '8',
    label: 'ESRGAN_4x',
  },
  {
    name: 'LDSR',
    value: '9',
    label: 'LDSR',
  },
  {
    name: 'R_ESRGAN_4X',
    value: '10',
    label: 'R-ESRGAN_4x+',
  },
  {
    name: 'R_ESRGAN_4X_ANIME6B',
    value: '11',
    label: 'R-ESRGAN_4x+ Anime6B',
  },
  {
    name: 'SCUNET_GAN',
    value: '12',
    label: 'ScuNET GAN',
  },
  {
    name: 'SCUNET_PSNR',
    value: '13',
    label: 'ScuNET PSNR',
  },
  {
    name: 'SWINIR_4X',
    value: '14',
    label: 'SwinIR_4x',
  },
  {
    name: 'ULTRASHARP_4X',
    value: '15',
    label: '4x-UltraSharp',
  },
  {
    name: 'NMKD_SIAX_200K_4X',
    value: '17',
    label: '4x_NMKD-Siax_200k',
  },
  {
    name: 'NMKD_SUPERSCALE_SP_178000_G_4X',
    value: '18',
    label: '4x_NMKD-Superscale-SP_178000_G',
  },
  {
    name: 'ANIMESHARP_4X',
    value: '19',
    label: '4x-AnimeSharp',
  },
  {
    name: 'FOOLHARDY_REMACRI_4X',
    value: '20',
    label: '4x_foolhardy_Remacri',
  },
  {
    name: 'BSRGAN',
    value: '21',
    label: 'BSRGAN',
  },
  {
    name: 'DAT_2',
    value: '22',
    label: 'DAT 2',
  },
  {
    name: 'DAT_3',
    value: '23',
    label: 'DAT 3',
  },
  {
    name: 'DAT_4',
    value: '24',
    label: 'DAT 4',
  },
  {
    name: 'DECOMPRESS_4X',
    value: '25',
    label: '4x-DeCompress',
  },
  {
    name: 'DECOMPRESS_STRONG_4X',
    value: '26',
    label: '4x-DeCompress Strong',
  },
  {
    name: 'NMKD_SUPERSCALE_8X',
    value: '16',
    label: '8x-NMKD-Superscale',
  },
];

export const generatingStatus = { pending: true, queueing: true, generating: true };

export const upscaleMethods = {
  default: '10',
  items: [
    {
      label: 'Latent',
      name: 'LATENT',
      value: '0',
    },
    {
      label: 'Latent (antialiased)',
      name: 'LATENT_ANTIALIASED',
      value: '1',
    },
    {
      label: 'Latent (bicubic)',
      name: 'LATENT_BICUBIC',
      value: '2',
    },
    {
      label: 'Latent (bicubic antialiased)',
      name: 'LATENT_BICUBIC_ANTIALIASED',
      value: '3',
    },
    {
      label: 'Latent (nearest)',
      name: 'LATENT_NEAREST',
      value: '4',
    },
    {
      label: 'Latent (nearest-exact)',
      name: 'LATENT_NEAREST_EXACT',
      value: '5',
    },
    {
      label: 'Lanczos',
      name: 'LANCZOS',
      value: '6',
    },
    {
      label: 'Nearest',
      name: 'NEAREST',
      value: '7',
    },
    {
      label: 'ESRGAN_4x',
      name: 'ESRGAN_4X',
      value: '8',
    },
    {
      label: 'LDSR',
      name: 'LDSR',
      value: '9',
    },
    {
      label: 'R-ESRGAN_4x+',
      name: 'R_ESRGAN_4X',
      value: '10',
    },
    {
      label: 'R-ESRGAN_4x+ Anime6B',
      name: 'R_ESRGAN_4X_ANIME6B',
      value: '11',
    },
    {
      label: 'ScuNET GAN',
      name: 'SCUNET_GAN',
      value: '12',
    },
    {
      label: 'ScuNET PSNR',
      name: 'SCUNET_PSNR',
      value: '13',
    },
    {
      label: 'SwinIR_4x',
      name: 'SWINIR_4X',
      value: '14',
    },
    {
      label: '4x-UltraSharp',
      name: 'ULTRASHARP_4X',
      value: '15',
    },
    {
      label: '4x_NMKD-Siax_200k',
      name: 'NMKD_SIAX_200K_4X',
      value: '17',
    },
    {
      label: '4x_NMKD-Superscale-SP_178000_G',
      name: 'NMKD_SUPERSCALE_SP_178000_G_4X',
      value: '18',
    },
    {
      label: '4x-AnimeSharp',
      name: 'ANIMESHARP_4X',
      value: '19',
    },
    {
      label: '4x_foolhardy_Remacri',
      name: 'FOOLHARDY_REMACRI_4X',
      value: '20',
    },
    {
      label: 'BSRGAN',
      name: 'BSRGAN',
      value: '21',
    },
    {
      label: 'DAT 2',
      name: 'DAT_2',
      value: '22',
    },
    {
      label: 'DAT 3',
      name: 'DAT_3',
      value: '23',
    },
    {
      label: 'DAT 4',
      name: 'DAT_4',
      value: '24',
    },
    {
      label: '8x-NMKD-Superscale',
      name: 'NMKD_SUPERSCALE_8X',
      value: '16',
    },
  ],
};

export const defaultHiResScale = 1.5;

export const presetNegativePromptOptions = [
  {
    label: translate('prompt_negative_standard'),
    value: 'common',
    text: 'EasyNegative, EasyNegativeV2, ng_deepnegative_v1_75t, worst quality, low quality',
  },
  {
    label: translate('prompt_negative_Anime'),
    value: 'anime',
    text: 'badhandv4, lowres, bad anatomy, bad hands, ((monochrome)), ((grayscale)) watermark',
  },
  {
    label: translate('prompt_negative_hands'),
    value: 'bad_hand',
    text: 'bad-hands-5,BadHandsV5',
  },
  {
    label: translate('prompt_negative_style'),
    value: 'bad_image',
    text: 'verybadimagenegative_v1.3, Bybadartist',
  },
  {
    label: translate('upscale_style_1'),
    value: 'real_portrait',
    text: 'illustration, 3d, 2d, painting, cartoons, sketch,text, error, missing fingers',
  },
];

export const presetNegativePrompts = Object.fromEntries(presetNegativePromptOptions.map((item) => [item.value, item]));

export const samplerMethodOptions = [
  {
    name: 'FLOW_MATCH_EULER',
    value: '31',
    label: 'Flow Match Euler',
    baseTypes: [7],
  },
  {
    name: 'DDPM',
    value: '32',
    label: 'DDPM',
    baseTypes: [8, 12],
  },
  {
    name: 'DPM_2M_KARRAS',
    value: '15',
    label: 'DPM++ 2M Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'EULER_A',
    value: '0',
    label: 'Euler a',
    baseTypes: [1, 3, 22, 8, 12, 10, 11],
    hunyuan: true,
  },
  {
    name: 'DPM_SDE_KARRAS',
    value: '16',
    label: 'DPM++ SDE Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_2S_A_KARRAS',
    value: '14',
    label: 'DPM++ 2S a Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_2M_SDE_KARRAS',
    value: '20',
    label: 'DPM++ 2M SDE Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_3M_SDE_Karras',
    value: '27',
    label: 'DPM++ 3M SDE Karras',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'DPM_2M',
    value: '7',
    label: 'DPM++ 2M',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11, 19, 21],
  },
  {
    name: 'EULER',
    value: '1',
    label: 'Euler',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11, 19, 21],
  },
  {
    name: 'RESTART',
    value: '29',
    label: 'Restart',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'DDIM',
    value: '17',
    label: 'DDIM',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_SDE',
    value: '8',
    label: 'DPM++ SDE',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_2S_A',
    value: '6',
    label: 'DPM++ 2S a',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11, 19, 21],
  },
  {
    name: 'DPM_3M_SDE_EXPONENTIAL',
    value: '28',
    label: 'DPM++ 3M SDE Exponential',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'DPM_ADAPTIVE',
    value: '10',
    label: 'DPM++ adaptive',
    baseTypes: [1, 3, 22, 9, 10, 11, 19, 21],
  },
  {
    name: 'DPM2_KARRAS',
    value: '12',
    label: 'DPM2 Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11, 19, 21],
  },
  {
    name: 'DPM_2M_SDE_EXPONENTIAL',
    value: '21',
    label: 'DPM++ 2M SDE Exponential',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'UNIPC',
    value: '19',
    label: 'UniPC',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM2_A_KARRAS',
    value: '13',
    label: 'DPM2 a Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_2M_SDE_HEUN_KARRAS',
    value: '24',
    label: 'DPM++ 2M SDE Heun Karras',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'DPM_2M_SDE_HEUN_EXPONENTIAL',
    value: '25',
    label: 'DPM++ 2M SDE Heun Exponential',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
  {
    name: 'DPM2_A',
    value: '5',
    label: 'DPM2 a',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM2',
    value: '4',
    label: 'DPM2',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11, 19, 21],
  },
  {
    name: 'LCM',
    value: '30',
    label: 'LCM',
    baseTypes: [8, 9, 12, 19, 21],
  },
  {
    name: 'LMS',
    value: '2',
    label: 'LMS',
    baseTypes: [1, 3, 22, 10, 11, 19, 21],
  },
  {
    name: 'HEUN',
    value: '3',
    hunyuan: true,
    label: 'Heun',
    baseTypes: [1, 3, 22, 8, 12, 10, 11, 19, 21],
  },
  {
    name: 'LMS_KARRAS',
    value: '11',
    label: 'LMS Karras',
    baseTypes: [1, 3, 22, 8, 9, 12, 10, 11],
  },
  {
    name: 'DPM_FAST',
    value: '9',
    label: 'DPM++ fast',
    baseTypes: [1, 3, 22, 9, 10, 11, 19, 21],
  },
  {
    name: 'PLMS',
    value: '18',
    label: 'PLMS',
    baseTypes: [1, 3, 22, 9, 10, 11],
  },
];

export const samplerMethodOptionsMap = Object.fromEntries(samplerMethodOptions.map((item) => [item.value, item]));
export const samplerMethodNamesMap = Object.fromEntries(samplerMethodOptions.map((item) => [item.value, item.name]));
export const samplerMethodValuesMap = Object.fromEntries(samplerMethodOptions.map((item) => [item.name, item.value]));

export const initialGeneratorParams = {
  primary: {
    baseType: MODEL_FLUX,
    presetBaseModelId: 'base_checkpoint',
    hiresOptions: { ...defaultHiresOptions },
    imageReference: null,
    prompt: '',
    negativePrompt: '',
    presetNegativePrompts: [],
    checkpoint: null,
    loraModels: [],
    addOns: [],
    count: 4,
    width: 768,
    height: 1024,
    icon: [9, 12],
    isFixedRatio: true,
    controlnets: [],
    samplerMethod: '1',
    samplingSteps: 30,
    seedType: '0',
    seedNumber: '',
    vae: '22541',
    cfgScale: 3.5,
    clipSkip: 2,
    colorControl: {
      colorPalette: [],
    },
  },
  inpaint: {
    baseType: MODEL_FLUX,
    modelPreset: 'original',
    presetBaseModelId: 'base_checkpoint',
    strength: 100,
    addOns: [],
    count: 1,
    controlnets: [],
    samplerMethod: '1',
    samplingSteps: 20,
    seedType: '0',
    seedNumber: '',
    vae: '22541',
    prompt: '',
    cfgScale: 7,
    clipSkip: 2,
  },
  outpaint: {
    modelPreset: 'common',
    checkpoint: null,
    loraModels: [],
    x: 0,
    y: 0,
    sampler: 'dpmpp_2m',
    scheduler: 'karras',
    samplingSteps: 20,
    count: 1,
    strength: 50,
    prompt: '',
  },
  upscale: {
    count: 1,
    scaleFactor: 2,
    upscaleType: '1',
    detailFactor: 0.3,
  },
  collage: {
    baseType: MODEL_SDXL,
    checkpoint: null,
    loraModels: [],
    addOns: [],
    strength: 50,
  },
};

export const vaeOptions = [
  {
    id: 1,
    value: '-1',
    uuid: 'none',
    versionUuid: 'none',
    label: translate('parameter_vae_auto'),
  },
  {
    id: 17592,
    value: '22541',
    uuid: '9c749a08a00509458caca99b66452a5f',
    versionUuid: '2c1a337416e029dd65ab58784e8a4763',
    label: 'vae-ft-mse-840000-ema-pruned',
  },
  {
    id: 17752,
    value: '22741',
    uuid: 'f02dc6d78f68f98d3b40086b0f09cccb',
    versionUuid: 'd4a03b32d8d59552194a9453297180c1',
    label: 'klF8Anime2VAE',
  },
  {
    id: 17754,
    value: '22743',
    uuid: '403a56fc8652a1831ab6337672e0f48e',
    versionUuid: 'd9be20ad5a7195ff0d97925e5afc7912',
    label: 'color101VAE',
  },
  {
    id: 17755,
    value: '22744',
    uuid: 'd92daf0eea720b5821cb65336ed1d9fd',
    versionUuid: '88ae7501f5194e691a1dc32d6f7c6f1a',
    label: 'cute',
  },
  {
    id: 17756,
    value: '22745',
    uuid: '4d4c972de1634d63d66d9331ae108164',
    versionUuid: '73f6e055eade7a85bda2856421d786fe',
    label: 'ClearVAE',
  },
  {
    id: 17757,
    value: '22746',
    uuid: '3cbd50fc7a63a7f353c05634cf49eceb',
    versionUuid: '5e93d0d2a64143a9d28988e75f28cb29',
    label: 'difconsistencyRAWVAE',
  },
];

export const comfySamplerOptions = [
  'euler',
  'euler_ancestral',
  'Heun',
  'heunpp2',
  'dpm_2',
  'dpm_2_ancestral',
  'lms',
  'dpm_fast',
  'dpm_adaptive',
  'dpm_2s_ancestral',
  'dpmpp_sde',
  'dpmpp_sde_gpu',
  'dpmpp_2m',
  'dpmpp_2m_alt',
  'dpmpp_2m_sde',
  'dpmpp_2m_sde_gpu',
  'dpmpp_3m_sde',
  'dpmpp_3m_sde_gpu',
  'ddpm',
  'lcm',
  'ddim',
  'uni_pc',
  'uni_pc_bh2',
];

export const comfySchedulerOptions = ['normal', 'karras', 'exponential', 'sgm_uniform', 'simple', 'ddim_uniform'];

export const comfyVaeNamesMap = {
  17752: 'kIF8Anime2VAE_kIF8Anime2VAE.ckpt',
  17754: 'color101VAE_v1.pt',
  20837: '通用风格SD XL 1.0',
  17592: 'vae-ft-mse-840000-ema-pruned.safetensors',
  17755: 'cute vae.safetensor',
  17756: 'ClearVAE_V2.3.safetensors',
  17757: 'difconsistencyRAWVAE_v10.pt',
};

export const upscaleNgPrompt = `(NSFW:2),legs apart,paintings,sketches,(worst quality:2),(low quality:2),(normal quality:2),lowres,normal quality,((monochrome)),((grayscale)),skin spots,acnes,skin blemishes,age spot,(outdoor:1.6),manboobs,backlight,(ugly:1.331),(duplicate:1.331),(morbid:1.21),(mutilated:1.21),(tranny:1.331),mutated hands,(poorly drawn hands:1.331),blurry,(bad anatomy:1.21),(bad proportions:1.331),extra limbs,(disfigured:1.331),(more than 2 nipples:1.331),(missing arms:1.331),(extra legs:1.331),(fused fingers:1.61051),(too many fingers:1.61051),(unclear eyes:1.331),bad hands,missing fingers,extra digit,(futa:1.1),bad body,ng_deepnegative_v1_75t,pubic hair,glans,refraction,diffusion,diffraction,nude,teeth,(worst quality, low quality:1.4),bad anatomy,low quality lowres very ugly fat obesity scar,low quality lowres chibi,low quality lowres poorly drawn bad anatomy,low quality lowres incoherent background,low quality lowres long body,low quality lowres duplicate comparison,low quality lowres sketch retro_artstyle doujinshi,low quality lowres sketch,low quality lowres text font ui error missing digit blurry,low quality lowres JPEG artifacts signature hazy bleary,low quality lowres monochrome parody meme,low quality lowres historical picture,low quality lowres disfigured mutated malformed twisted human body,low quality lowres futanari tranny,low quality lowres tentacle skeleton,watermark,signature,fewer digits,figure,fat,`;

export const upscaleSettingScalesList = [
  {
    label: '2 x',
    value: 2,
  },
  {
    label: '3 x',
    value: 3,
  },
  {
    label: '4 x',
    value: 4,
  },
  {
    label: '6 x',
    value: 6,
  },
  {
    label: '8 x',
    value: 8,
  },
];

export const upscaleStylesList = [
  {
    // 真实人相
    label: translate('upscale_style_1'),
    value: '1',
    checkpointId: 125488,
    checkpointId_shakker: 125488,
    lora: {
      sd_v2: 1,
      more_detail: 0.6,
    },
    upscale_strength: 0.5,
    upscale_lora_weight: 0.72,
    upscale_cfgScale: 0,
    upscale_controlWeight: 0.84,
    tile: 15,
  },
  {
    // 动漫
    label: translate('upscale_style_2'),
    value: '2',
    checkpointId: 1510510,
    checkpointId_shakker: 1487747,
    lora: {
      sd_v2: 0,
      more_detail: 0.8,
    },
    upscale_strength: 0.5,
    upscale_lora_weight: 0.72,
    upscale_cfgScale: 0,
    upscale_controlWeight: 0.84,
    tile: 11,
  },
  {
    // cg
    label: translate('upscale_style_3'),
    value: '3',
    checkpointId: 30286,
    checkpointId_shakker: 1485189,
    lora: {
      sd_v2: 1,
      more_detail: 0.6,
    },
    upscale_strength: 0.5,
    upscale_lora_weight: 0.72,
    upscale_cfgScale: 0,
    upscale_controlWeight: 0.84,
    tile: 15,
  },
  {
    // 插画
    label: translate('upscale_style_4'),
    value: '4',
    checkpointId: 1510510,
    checkpointId_shakker: 1487747,
    lora: {
      sd_v2: 0,
      more_detail: 0.8,
    },
    upscale_strength: 0.5,
    upscale_lora_weight: 0.72,
    upscale_cfgScale: 0,
    upscale_controlWeight: 0.84,
    tile: 15,
  },
  {
    // 3d
    label: translate('upscale_style_5'),
    value: '5',
    checkpointId: 22914,
    checkpointId_shakker: 1485135,
    lora: {
      sd_v2: 0,
      more_detail: 0.6,
    },
    upscale_strength: 0.5,
    upscale_lora_weight: 0.72,
    upscale_cfgScale: 0,
    upscale_controlWeight: 0.84,
    tile: 15,
  },
];
